export class License {
    id: number;
    type: string;
    credits: number;
    frequency: number;
    active: boolean;
    track_credits: boolean;
    subscription_id: number;
    device_id: number;
    account_id: number;
    previous_credit: string;
    next_credit: string;
    expires: string;

    constructor(
    ) {
        this.active = true;
        this.track_credits = false;
     }

}


export enum LicenseTypes {
    HEARSCREENSTANDARD = 'HEARSCREEN.STANDARD',
    HEARTESTSTANDARD = 'HEARTEST.STANDARD',
    PEEKACUITYSTANDARD = 'PEEKACUITY.STANDARD',
    SEALCHECKSTANDARD = 'SEALCHECK.STANDARD',
    SEALCHECKSTANDARD_VARIPHONE = 'SEALCHECK.STANDARD_VARIPHONE',
    HEARKIOSKDIN = 'HEARKIOSK.DIN',
    HEARKIOSKPTA = 'HEARKIOSK.PTA',
    HEARTEST_OCCHEALTH_STANDARD = 'HEARTEST_OCCHEALTH.STANDARD',
    SELFTESTBUNDLE = 'BUNDLE.SELFTEST',
    HEARSPEECHSTANDARD = 'HEARSPEECH.STANDARD',
    VISIONSTANDARD = 'VISION.STANDARD',
    HEARSCOPE = 'HEARSCOPE.STANDARD',
}

export enum FrequencyTypes {
    MONTHLY = 'month',
    ANNUALLY = 'year',
}



// WEBPACK FOOTER //
// ./src/app/models/license.ts